import { action, computed } from "mobx";
import http from "@app/lib/http";

import BaseStore from "@app/state/store/base";

import report from "../../../report";

export class ExclusionStore extends BaseStore {
    observable() {
        return {
            loading: false,
            list: [],
            stats: {},
        };
    }

    @computed get busy() {
        return this.loading;
    }

    @computed get project() {
        return report.id;
    }

    @action
    async load(type) {
        this.loading = true;

        let { data } = await http.get(`/project/${this.project}/reports/exclusion/${type}`);

        this.list = data.list;
        this.stats = data.stats;

        this.loading = false;
    }
}

export default new ExclusionStore();
